import React, { useState, useRef, useEffect } from 'react';
import { Col, Divider, Row, message as Message } from 'antd';
import {
  SwipeableList,
  SwipeableListItem,
  ActionAnimations,
} from '@sandstreamdev/react-swipeable-list';
import '@sandstreamdev/react-swipeable-list/dist/styles.css';
import { FaCcVisa, FaCheckCircle } from 'react-icons/fa';
import Visa from '../../assets/images/svg/icons8-visa.svg';
import Mastercard from '../../assets/images/svg/icons8-mastercard.svg';
import { useDispatch, useSelector } from 'react-redux';
import { selectCard } from '../../store/payment/actions';
import { getCustomerState } from '../../store/payment/selectors';

export interface PaymentCardProps {
  cards: any;
}

export const SwipeContent: React.FC = () => {
  return (
    <div className="swip-delete">
      <span>Delete</span>
    </div>
  );
};

export const PaymentCardList: React.FC<PaymentCardProps> = ({ cards }) => {
  const dispatch = useDispatch();
  const { customers, selected } = useSelector(getCustomerState);
  const onSwipeDelete = (item: any) => {
    if (window.confirm('Are you sure you want to delete?')) {
      console.log('deleted', item);
      return;
    }
    console.log('cancelled');
  };
  const onClickItem = (item: any) => {
    if (window.confirm('Are you sure to select this card?')) {
      dispatch(selectCard(item.id));
    }
  };
  console.log('wew', customers);
  return (
    <Col span={24} className="payment-list">
      <div>
        {cards.map(
          (
            item: {
              id: string;
              customers: { card: { brand: string; last4: string } };
            },
            i: string | number | undefined
          ) => (
            <div
              key={i}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                onClickItem(item);
              }}
            >
              <SwipeableList threshold={0.3} swipeStartThreshold={5}>
                <SwipeableListItem
                  swipeLeft={{
                    content: <SwipeContent />,
                    actionAnimation: ActionAnimations.NONE,
                    action: () => {
                      onSwipeDelete(item);
                    },
                  }}
                >
                  <Row>
                    <div>
                      {item.customers.card.brand === 'Visa' ? (
                        <img
                          src={Visa}
                          alt="visa credit card"
                          className="cc-logo active"
                        />
                      ) : (
                        <img
                          src={Mastercard}
                          alt="visa credit card"
                          className="cc-logo active"
                        />
                      )}
                    </div>
                    <div className="payment-card">
                      {`**** **** **** ${item.customers.card.last4}`}
                    </div>
                    {selected && selected === item.id ? (
                      <div className="payment-default">
                        <FaCheckCircle color="#00A75A" />
                      </div>
                    ) : null}
                  </Row>
                </SwipeableListItem>
              </SwipeableList>
              <Divider />
            </div>
          )
        )}
      </div>
    </Col>
  );
};
